export const SUPPORTED_IMAGE_TYPES = {
  'image/jpeg': [],
  'image/png': [],
  'image/webp': []
};

export const FORM_SECTIONS = {
  BUSINESS_LOGO: {
    title: 'Business logo',
    description: 'This logo will be showing in your profile and invoice, etc.'
  },
  TEAM_NAME: {
    title: 'Team name',
    description: 'Your team name will be displayed on all invoices, payments, and receipts for your team'
  },
  LABEL: {
    title: 'Team label',
    description:
      'A short label to identify this team. Only visible to you and your team - never appears on invoices, ' +
      'receipts, or customer statements.\nEx: Downtown, Route 4, Commercial'
  },
  STATEMENT_DESCRIPTOR: {
    title: 'Statement descriptor',
    description: 'This is the business name that will show up on your customers bank or credit card statements.'
  },
  DESCRIPTION: {
    title: 'Description',
    description: 'A brief about your team and the services they provide.'
  },
  PROFESSION: {
    title: 'Profession',
    description: 'Category of your business'
  },
  BUSINESS_ADDRESS: {
    title: 'Business address',
    description: 'Registered business address'
  },
  CONTACT_DETAILS: {
    title: 'Contact details',
    description: 'Online & direct contacts'
  }
} as const;

export const CONTACT_PLACEHOLDERS = {
  PHONE: 'Enter phone number',
  EMAIL: 'Enter email address',
  WEBSITE: 'Enter website link',
  YELP: 'E.g. yelp.com/your-business',
  FACEBOOK: 'E.g. facebook.com/your-business',
  OTHER: 'E.g. bing.com/your-business'
} as const;
